import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Back } from '@pulse-web-ui/icons';

import { addTestAttribute } from '@shared/index';

import { PageBackButton } from './buttons';

interface Props {
  goBack?: () => void;
  testId?: string;
}

export const BackButton = ({ goBack, testId = 'page' }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <PageBackButton
      onClick={goBack || handleBack}
      icon={<Back viewBox='0 0 20 16' />}
      {...addTestAttribute(`${testId}.backButton`)}
    >
      {t('COMMON:buttons.back')}
    </PageBackButton>
  );
};
